<template>
    <form-wrapper class="practice-information-form" @submit="handleFormSubmission(data)">
        <div class="profile-main-data">
            <h1 class="headings">{{ $t('forms.patient.patient_information.fields.inform.label') }}</h1>
            <form-row>
                <form-cell width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient_profile.fields.profile.first_name.label')"
                        :placeholder="$t('forms.patient_profile.fields.profile.first_name.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="firstName"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
                <form-cell width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient_profile.fields.profile.last_name.label')"
                        :placeholder="$t('forms.patient_profile.fields.profile.last_name.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="lastName"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>
            <form-row>
                <form-cell width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.date.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.date.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="dob"
                        type="date"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
                <form-cell width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.email.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.email.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="email"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>
            <form-row>
                <form-cell width="half">
                    <phone-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.phone.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.phone.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="mobilePhone"
                        type="number"
                        @change="change($event)"
                    ></phone-field>
                </form-cell>
                <form-cell width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.SSN.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.SSN.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="ssn"
                        type="number"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
                <!-- <form-cell width="half">
                    <suggest-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.location_address.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.location_address.placeholder')"
                        :suggestionsCall="addressSuggestionCall"
                        :isRequired="true"
                        :isDisabled="!isEditable"
                        :isSuggested="false"
                        :formData="data"
                        valuePath="address"
                        @change="change($event)"
                        @select="changeLocationAddress($event)"
                    ></suggest-field>
                </form-cell> -->
            </form-row>
            <!-- <form-row>
                <form-cell width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.SSN.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.SSN.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="ssn"
                        type="number"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row> -->
        </div>
        <div class="profile-main-data">
            <h1 class="headings">{{ $t('forms.patient.patient_information.fields.inform.label_3') }}</h1>
            <form-row>
                <form-cell>
                    <suggest-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.location_address.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.location_address.placeholder')"
                        :suggestionsCall="addressSuggestionCall"
                        :isRequired="true"
                        :isDisabled="!isEditable"
                        :isSuggested="false"
                        :formData="data"
                        valuePath="address"
                        @change="change($event)"
                        @select="changeLocationAddress($event)"
                    ></suggest-field>
                </form-cell>
                <form-cell v-if="isEditable" width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.city.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.city.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="city"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
                <form-cell v-if="isEditable" width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.state.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.state.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="state"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
                <form-cell v-if="isEditable" width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.zip.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.zip.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="zip"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>
            <form-row v-if="isEditable">
                <form-cell width="quarter">
                    <text-field
                        :label="$t('forms.addpatient.fields.floor_number.label')"
                        :placeholder="$t('forms.addpatient.fields.floor_number.placeholder')"
                        :isDisabled="isDisabled"
                        :isSuggested="false"
                        :formData="data"
                        errorPath="floorNumber"
                        valuePath="floorNumber"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
                <form-cell width="quarter">
                    <text-field
                        :label="$t('forms.addpatient.fields.apartment_number.label')"
                        :placeholder="$t('forms.addpatient.fields.apartment_number.placeholder')"
                        :isDisabled="isDisabled"
                        :isSuggested="false"
                        :formData="data"
                        errorPath="apartmentNumber"
                        valuePath="apartmentNumber"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
                <form-cell width="quarter">
                    <text-field
                        :label="$t('forms.addpatient.fields.building_number.label')"
                        :placeholder="$t('forms.addpatient.fields.building_number.placeholder')"
                        :isDisabled="isDisabled"
                        :isSuggested="false"
                        :formData="data"
                        errorPath="buildingNumber"
                        valuePath="buildingNumber"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>
        </div>
        <div class="profile-main-data">
            <h1 class="headings">{{ $t('forms.patient.patient_information.fields.inform.label_1') }}</h1>
            <form-row>
                <form-cell width="half" class="patient-option">
                    <label class="form-field__label">
                        {{ $t('forms.patient.patient_information.fields.insurance_plans.placeholder_patient') }}
                    </label>
                    <select-input
                        class="patient-detail-form-text"
                        :isDisabled="!isEditable"
                        :placeholder="$t('forms.patient.patient_information.fields.insurance_plans.start_typing')"
                        :options="insurancePlans"
                        :groupOptions="true"
                        :expandOptionsRight="true"
                        :isSearchable="true"
                        :value="insuranceId"
                        @change="changeInsurance($event)"
                    ></select-input>
                    <span class="option-active">
                        {{ $t('forms.patient.patient_information.fields.insurance_plans.options') }}
                    </span>
                </form-cell>
                <form-cell width="half" class="patient-option">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.Insurance.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.Insurance.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="insuranceGroupNumber"
                        @change="change($event)"
                    ></text-field>
                    <span class="option">{{ $t('forms.patient.patient_information.fields.Insurance.options') }}</span>
                </form-cell>
            </form-row>
            <form-row>
                <form-cell width="half" class="patient-option">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.Insurance_id.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.Insurance_id.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="memberId"
                        @change="change($event)"
                    ></text-field>
                    <span class="option">{{ $t('forms.patient.patient_information.fields.Insurance.options') }}</span>
                </form-cell>
            </form-row>
        </div>
        <div class="profile-main-data">
            <h1 class="headings">{{ $t('forms.patient.patient_information.fields.inform.label_2') }}</h1>
            <form-row>
                <form-cell width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.guarantor.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.guarantor.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="guarantor"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
                <form-cell width="half">
                    <text-field
                        class="patient-detail-form-text"
                        :label="$t('forms.patient.patient_information.fields.guarantor_Number.label')"
                        :placeholder="$t('forms.patient.patient_information.fields.guarantor_Number.placeholder')"
                        :isDisabled="!isEditable"
                        :isRequired="false"
                        :formData="data"
                        valuePath="guarantorPhoneNumber"
                        type="number"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>
        </div>
        <div v-if="isEditable">
            <common-buttons style="margin-top: 20px">
                <common-button
                    :isSubmittable="false"
                    :label="$t('pages.patient.details.buttons.secondary')"
                    type="secondary"
                    @click="handleCancel"
                ></common-button>
                <common-button
                    :isProcessing="isSending"
                    :label="$t('pages.patient.details.buttons.primary')"
                    type="primary"
                ></common-button>
            </common-buttons>
        </div>
        <patient-message-modal
            :isOpen="physician.PatientMessage"
            @close="closeModal('toggle-patient-message-modal')"
        ></patient-message-modal>
        <check-password-modal
            :isOpen="physician.CheckPassword"
            @close="closeModal('toggle-check-password-modal')"
            @edit-patient="editPatientEnable"
        ></check-password-modal>
        <delete-patient-modal
            :isOpen="physician.DeletePatient"
            @close="closeModal('toggle-delete-patient-modal')"
        ></delete-patient-modal>
        <direct-referral
            v-if="physician.DirectReferral"
            :insurancePlanId="patientInsuranceId"
            :patientId="Number($route.params.id)"
            @close="closeModal('toggle-direct-referral-modal')"
        ></direct-referral>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PatientMessageModal from 'components/page-elements/patient/PatientMessageModal'
    import CheckPasswordModal from 'components/page-elements/patient/CheckPasswordModal'
    import DeletePatientModal from 'components/page-elements/patient/DeletePatientModal'
    import PatientAPI from 'api/PatientAPI'
    import isEqual from 'lodash.isequal'
    import PhysicianMixin from 'mixins/PhysicianMixin'
    import DirectReferral from 'components/page-elements/referrals/DirectReferral'
    import Store from '~/store'
    import FormDisableableMixin from 'mixins/FormDisableableMixin'

    export default {
        mixins: [FormMixin, HandleRequestMixin, PhysicianMixin, FormDisableableMixin],
        components: { PatientMessageModal, CheckPasswordModal, DeletePatientModal, DirectReferral },

        props: {
            physician: { type: Object, required: true },
            patientDetails: { type: Object, required: true },
        },

        data() {
            return {
                insuranceId: null,
                insurancePlans: [],
                initialData: {},
                maxNumberOfItems: null,
                isEditable: false,
                patientInsuranceId: '',
            }
        },

        computed: {
            addressSuggestionCall() {
                //eslint-disable-next-line no-undef
                const autocompleteService = new google.maps.places.AutocompleteService()
                return (query) => {
                    const request = {
                        input: query,
                        componentRestrictions: { country: 'US' },
                    }
                    return autocompleteService.getPlacePredictions(request).then((results) => {
                        return results?.predictions?.map((item) => {
                            return {
                                label: item.description,
                                value: item.place_id,
                            }
                        })
                    })
                }
            },
        },

        methods: {
            closeModal(modalName) {
                this.$emit('toggle', modalName)
            },
            editPatientEnable() {
                this.isEditable = true
                this.data.address = this.patientDetails.address

                this.$emit('toggle', 'toggle-check-password-modal')
            },
            handleCancel() {
                this.isEditable = false
                this.data.address = this.getFullAddress(this.patientDetails)
            },
            changeInsurance(event) {
                this.insuranceId = event
            },

            getFullAddress(source) {
                return `${source.address}, ${source.city}, ${source.state}, ${source.zip}${this.getFloor(source)}${this.getApt(
                    source,
                )}${this.getBuilding(source)}`
            },

            getFloor(source) {
                return source.floorNumber ? `, floor: ${source.floorNumber}` : ''
            },

            getApt(source) {
                return source.apartmentNumber ? `, apt: ${source.apartmentNumber}` : ''
            },

            getBuilding(source) {
                return source.buildingNumber ? `, building: ${source.buildingNumber}` : ''
            },

            changeLocationAddress(payload) {
                if (!payload?.value) {
                    return
                }
                //eslint-disable-next-line no-undef
                const placesService = new google.maps.places.PlacesService(document.createElement('div'))
                const request = {
                    placeId: payload.value,
                    fields: ['address_components'],
                }

                placesService.getDetails(request, (place, status) => {
                    //eslint-disable-next-line no-undef
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        const addressComponents = {}
                        place.address_components.forEach((component) => {
                            component.types.forEach((type) => {
                                switch (type) {
                                    case 'street_number':
                                        addressComponents.streetNumber = component.long_name
                                        break
                                    case 'route':
                                        addressComponents.address = component.long_name
                                        break
                                    case 'locality':
                                        addressComponents.city = component.long_name
                                        break
                                    case 'administrative_area_level_1':
                                        addressComponents.state = component.short_name
                                        break
                                    case 'postal_code':
                                        addressComponents.zipCode = component.long_name
                                        break
                                }
                            })
                        })

                        this.$set(
                            this.data,
                            'address',
                            `${addressComponents.streetNumber || ''} ${addressComponents.address || ''}`,
                        )
                        this.$set(this.data, 'city', addressComponents.city || '')
                        this.$set(this.data, 'state', addressComponents.state || '')
                        this.$set(this.data, 'zip', addressComponents.zipCode || '')
                        this.isSuggested = true
                    }
                })
            },

            handleFormSubmission(data) {
                this.isSending = true
                this.emitEvent({ name: 'is-sending', payload: this.isSending })
                const patientId = this.$route.params.id
                const newData = {
                    primaryInsuranceTypeId: this.insuranceId,
                    groupNumber: data.insuranceGroupNumber,
                    memberId: data.memberId,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    dob: data.dob,
                    last4ssn: data.ssn,
                    email: data.email,
                    phoneNumber: data.mobilePhone,
                    address: {
                        address: data.address || '',
                        city: data.city || '',
                        state: data.state || '',
                        zip: data.zip || '',
                        floorNumber: data.floorNumber || '',
                        apartmentNumber: data.apartmentNumber || '',
                        buildingNumber: data.buildingNumber || '',
                    },
                    guarantor: {
                        firstName: data.guarantor,
                        phone: data.guarantorPhoneNumber,
                    },
                }
                this.handleRequest(PatientAPI.updatePatientDetails(patientId, this.$auth.getUser().id, newData))
                    .then(() => {
                        this.isEditable = false
                        this.data.address = this.getFullAddress(newData.address)
                    })
                    .finally(() => {
                        this.isSending = false
                        this.emitEvent({ name: 'is-sending', payload: this.isSending })
                        this.emitEvent({ name: 'updateDetailPage' })
                        this.isEditable = false
                    })
            },

            setNumberOfItems() {
                if (this.isTablet) {
                    this.maxNumberOfItems = 1
                    return
                }
                if (this.isLaptop) {
                    this.maxNumberOfItems = 2
                    return
                }

                this.maxNumberOfItems = 3
            },
        },

        watch: {
            patientDetails: {
                handler(newVal) {
                    if (newVal && Object.keys(newVal).length) {
                        this.patientInsuranceId = newVal?.mcard?.primaryInsuranceTypeId
                        this.insuranceId = newVal?.mcard?.primaryInsuranceTypeId
                        this.data = {
                            insuranceGroupNumber: newVal?.mcard?.groupNumber ?? 'N/A',
                            memberId: newVal?.mcard?.memberId ?? 'N/A',
                            firstName: newVal.firstName ?? 'N/A',
                            lastName: newVal.lastName ?? 'N/A',
                            dob: newVal.dateOfBirth ?? null,
                            ssn: newVal.ssn ?? null,
                            email: newVal.email ?? 'N/A',
                            address: newVal?.address ? this.getFullAddress(newVal) : 'N/A',
                            city: newVal.city ?? 'N/A',
                            state: newVal.state ?? 'N/A',
                            zip: newVal.zip ?? 'N/A',
                            floorNumber: newVal.floorNumber ?? 'N/A',
                            apartmentNumber: newVal.apartmentNumber ?? 'N/A',
                            buildingNumber: newVal.buildingNumber ?? 'N/A',
                            mobilePhone: newVal.mobilePhone ?? null,
                            guarantor: newVal.guarantor ?? 'N/A',
                            guarantorPhoneNumber: newVal.guarantorPhoneNumber ?? null,
                        }
                    }
                },
                immediate: true,
                deep: true,
            },
            windowWidth() {
                this.setNumberOfItems()
            },
        },

        mounted() {
            this.insurancePlans = Store.getters['auth/getInsurancePlans']
            this.setNumberOfItems()
            this.$on('local:afterChange', () => {
                this.emitEvent({ name: 'form-changed', payload: !isEqual(this.initialData, this.data) })
            })
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .profile-main-data {
        background-color: #fff;
        border: 1px solid #ddd;
        border-radius: 10px;
        padding: 12px;
        margin-bottom: 25px;
    }
    span.option {
        position: absolute;
        top: 0;
        left: 158px;
        font-size: 12px;
        border: 1px solid #ddd;
        padding: 2px 9px;
        border-radius: 5px;
        color: oklch(0.145 0 0);
        font-size: 14px;
        font-weight: 500;
    }
    span.option-active {
        position: absolute;
        top: 0;
        left: 140px;
        font-size: 12px;
        border: 1px solid oklch(0.962 0.044 156.743);
        padding: 2px 9px;
        border-radius: 5px;
        color: oklch(0.448 0.119 151.328);
        font-size: 14px;
        font-weight: 500;
        background-color: oklch(0.962 0.044 156.743);
    }
    .patient-option {
        position: relative;
    }
    .grid__column {
        @include breakpoint(laptop) {
            -ms-flex-preferred-size: 50%;
            flex-basis: 33% !important;
        }
    }
    .patient-name {
        @include breakpoint(laptop) {
            text-align: start;
            font-size: 14px;
            font-weight: 600;
            color: #242128;
            white-space: nowrap;
            width: 123px !important;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>
